<template>
  <div class="position-relative" id="subheader">
    <b-container>
      <b-row align-v="center" no-gutters>
        <b-col cols="auto" lg="9" xl="auto" class="position-static">
          <nav class="main-nav d-none d-md-inline-block">
            <ul class="main-nav-list list-unstyled">
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://jobmatch.works/${lang}/index.php`" class="main-nav-link">
                    Willkommen
                  </a>
                </div>
              </li>
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://jobmatch.works/${lang}/Plattformen/index.php`" class="main-nav-link">
                    Digitale Lösungen
                  </a>
                  <ul>
                    <li>
                      <a :href="`https://jobmatch.works/${lang}/Plattformen/index.php`" target="_blank">
                        Bedarfe und Herausforderungen
                      </a>
                    </li>
                    <li>
                      <a :href="`https://jobmatch.works/${lang}/Plattformen/loesungsansatz.php`" target="_blank">
                        Lösungskomponenten - Job Talent Space und TALENTRO
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://jobmatch.works/${lang}/Arbeitgeberservice/index.php`" class="main-nav-link">
<!--                    Projektunterstützung-->
                    Arbeitgeberservice
                  </a>
<!--                  <ul>-->
<!--                    <li>-->
<!--                      <a :href="`https://jobmatch.works/${lang}/Projektsupport/deutschtraining.ph`" target="_blank">-->
<!--                        Deutschtraining-->
<!--                      </a>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <a :href="`https://jobmatch.works/${lang}/Projektsupport/index.php`" target="_blank">-->
<!--                        Angebote zur Projektunterstützung-->
<!--                      </a>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <a :href="`https://jobmatch.works/${lang}/Projektsupport/integrationscoaching.php`" target="_blank">-->
<!--                        Integrationscoaching-->
<!--                      </a>-->
<!--                    </li>-->
<!--                  </ul>-->
                </div>
              </li>
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://jobmatch.works/${lang}/Deutschtraining/index.php`" class="main-nav-link">
<!--                    DaF/DaZ-->
                    Deutschtraining
                  </a>
                  <ul>
                    <li><a :href="`https://jobmatch.works/${lang}/Deutschtraining/Deutschlernplattform.php`" target="_blank">Deutschlernplattform</a></li>
                    <li><a :href="`https://jobmatch.works/${lang}/Deutschtraining/Deutschlehrkraefte.php`" target="_blank">Deutschlehrkräfte</a></li>
                    <li><a :href="`https://jobmatch.works/${lang}/Deutschtraining/Deutschlerninhalte.php`" target="_blank">Deutschlerninhalte</a></li>
                    <li><a :href="`https://jobmatch.works/${lang}/Deutschtraining/Deutschpruefungen.php`">Deutschprüfungen</a></li>
                  </ul>
                </div>
              </li>
              <li class="main-nav-item d-none d-lg-inline-block">
                <div class="main-nav-link-wrapper">
                  <router-link
                    tabindex="0"
                    to="/"
                    class="btn btn-primary d-none d-lg-block m-0 ml-half text-white fw-bold main-nav-link-btn"
                    aria-current="page"
                  >
                    {{ translations[14997] }}
                  </router-link>
                  <ul>
                    <li><a :href="`https://jobmatch.works/${lang}/Job-Talent-Space/Auf-einen-Blick.php`" target="_blank">{{ translations[15401] }}</a></li>
                    <li><a :href="`https://jobmatch.works/${lang}/Job-Talent-Space/FAQ.php`" target="_blank">FAQ</a></li>
                  </ul>
                </div>
              </li>
<!--              <li class="main-nav-item">-->
<!--                <div class="main-nav-link-wrapper">-->
<!--                  <a target="_blank" :href="`https://jobmatch.works/${lang}/Ueber-uns/index.php`" class="main-nav-link">-->
<!--                    Über uns-->
<!--                  </a>-->
<!--                </div>-->
<!--              </li>-->
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://jobmatch.works/${lang}/Kontakt/index.php`" class="main-nav-link">
                    Kontakt
                  </a>
                  <ul>
                    <li><a :href="`https://jobmatch.works/${lang}/Kontakt/index.php`" target="_blank">So erreichen Sie uns</a></li>
                    <li><a :href="`https://jobmatch.works/${lang}/Kontakt/impressum.php`" target="_blank">Impressum</a></li>
                    <li><a :href="`https://jobmatch.works/${lang}/Kontakt/form.php`" target="_blank">Kontaktformular</a></li>
                    <li><a :href="`https://jobmatch.works/${lang}/Kontakt/Datenschutz.php`" target="_blank">Datenschutz</a></li>
                  </ul>
                </div>
              </li>

            </ul>
          </nav>
        </b-col>
        <b-col cols="auto" class="d-flex ml-auto align-items-center">
          <!-- Logo -->
          <a :href="`https://jobmatch.works/${lang}/index.php`" class="d-block ml-2">
            <div class="py-1 py-sm-3 h-100">
              <img :src="require('@/assets/img/logo/logo-work-talenpool.svg')" alt="talenpool" class="img img-fluid logo-header" />
            </div>
          </a>
          <!-- /Logo -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  components: {
    LanguageHeader,
  },
})
export default class HeaderInformationNavigation extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return 'de';// AppModule.language;
  }
}
</script>
<style scoped lang="scss">
[theme="default"] {
  #subheader {
    background-color: white !important;
  }
  .logo-header {
    max-width: 150px;
    @media (min-width: 786px) {
      max-width: 200px;
    }
    @media (min-width: 1400px) {
      max-width: 230px;
    }
  }
  .main-nav-item {
    margin: 0 3px 0 0;
    ul li a {
      font-size: 16px;
    }
  }
  .main-nav-link {
    color: #68726A;
    font-weight: 500;
    background-color: #EEF1F0;
    padding: 5px 15px;
    margin: 5px 0;
    border-radius: 5px;
    transition: none;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
    &:hover, &:active {
      background-color: var(--portal-primary);
      color: #ffffff!important;
    }
  }
  .main-nav-link-btn {
    font-weight: 500;
    padding: 5px 15px;
    margin: 5px 0;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
  }
  .auth-cabinet .logo-header {
    height: auto;
  }
}

.main-nav-list {
  background: #ffffff;
  padding: 0;
  margin: 0;
}
.main-nav-link-wrapper {
  >a, >a:visited, >a:active, >a:hover {
    color: rgb(var(--portal-secondary-600));
    text-decoration: none;
  }
}

//sub-nav
ul.main-nav-list li:hover div > ul {
  visibility: visible;
  opacity: 1;
}
ul.main-nav-list ul {
  list-style: none;
  margin: 5px 0 0;
  padding: 10px 0 0;
  visibility: hidden;
  position: absolute;
  z-index: 99999;
  opacity: 0;
  -webkit-transition: opacity 0.2s linear, visibility 0.2s linear;
  -moz-transition: opacity 0.2s linear, visibility 0.2s linear;
  -o-transition: opacity 0.2s linear, visibility 0.2s linear;
  transition: opacity 0.2s linear, visibility 0.2s linear;
  top: 100%;
  left: 0px;
  text-transform: none;
  font-weight: 600;
  line-height: 1.4em;
  -moz-box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  width: 250px;
  overflow: hidden;
  background: var(--portal-primary);
}

ul.main-nav-list ul li {
  clear: both;
  width: 100%;
  background: none transparent;
}
ul.main-nav-list ul li {
  display: inline;
  float: left;
  margin: 0;
  padding: 0;
  position: relative;
  background-image: none;
  border-radius: 5px;
  margin-right: 2px;
}
ul.main-nav-list ul li a {
  padding: 3px 10px 3px 12px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  display: block;
  border: 0 none;
  clear: both;
  border-radius: 0px;
  background-color: transparent;
}
ul.main-nav-list ul li a:hover,
ul.main-nav-list ul li.active a {
  color: white;
}
ul.main-nav-list ul li:last-child a {
  padding: 3px 10px 12px 12px;
}
</style>
